module.exports = __webpack_public_path__ + "img/fin-agent-save-snippet-dark.dad8af6.svg";